module.exports = __webpack_public_path__ + "img/SL-M-200-280.510eac7f.svg";